import { AdminProjectPlan, TeamMatchDetails } from '@platform/client/schemas';
import {
  OrganizationProfileLink,
  ProfileItem,
  ProfileSection,
  ProfileTabContainer,
  ProjectProfileLink,
} from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';
import { ProjectPlanSection } from '../../components/ProjectPlanSection';
import { ProfessionalLink } from '../professionals/ProfessionalsAdmin';

export const DetailsTabContent = ({
  teamMatchData,
  projectPlanData,
}: {
  teamMatchData?: TeamMatchDetails | null;
  projectPlanData?: AdminProjectPlan | null;
}) => {
  return (
    <ProfileTabContainer>
      <DetailsSection teamMatchData={teamMatchData} />
      {projectPlanData && <ProjectPlanSection planData={projectPlanData} />}
    </ProfileTabContainer>
  );
};

const DetailsSection = ({ teamMatchData }: { teamMatchData?: TeamMatchDetails | null }) => {
  return (
    <ProfileSection title='Discovery Details'>
      <OrganizationProfileLink
        organizationId={teamMatchData?.organization.id}
        organizationName={teamMatchData?.organization.name}
      />
      <ProfileItem
        label='Professionals'
        value={teamMatchData?.team.members.map((member, index) => (
          <span>
            <ProfessionalLink
              key={member.id}
              userId={member.id}
              name={member.firstName + ' ' + member.lastName}
            />
            {index < teamMatchData.team.members.length - 1 && ', '}
          </span>
        ))}
      />
      <ProjectProfileLink
        projectId={teamMatchData?.project?.id}
        projectName={teamMatchData?.project?.name}
      />
      <ProfileItem label='Cohort' value={teamMatchData?.cohort.name} />
      <ProfileItem
        label='Representative'
        value={
          teamMatchData?.representative?.firstName + ' ' + teamMatchData?.representative?.lastName
        }
      />
      <ProfileItem label='Corporate Client' value={teamMatchData?.corporateClient.name} />
      <ProfileItem label='Match Status' value={teamMatchData?.myProjectsStatus} />
      <ProfileItem
        label='Match Status Date'
        value={
          teamMatchData?.myProjectsStatusDate ?
            formatDateStr(teamMatchData?.myProjectsStatusDate)
          : undefined
        }
      />
    </ProfileSection>
  );
};
